import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

const initialState: boolean = false;

export const clearFilterSlice = createSlice({
 name: 'clearFilter',
 initialState,
 reducers: {
  clearFilter: (state, action: PayloadAction<boolean>) => {
   state = action.payload;
   return state;
  },
 },
});

export const { clearFilter } = clearFilterSlice.actions;

export default clearFilterSlice.reducer;
